import React from 'react';
import { Mail, MessageCircle, CheckCircle } from 'lucide-react';

const AfterPaymentBlock = () => {
  return (
    <div className="p-6 sm:p-8 rounded-2xl bg-gradient-to-br from-emerald-500/10 to-teal-500/5 border border-emerald-500/30 mb-8">
      <h4 className="text-xl sm:text-2xl font-black text-white mb-4 flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center">
          <CheckCircle className="w-5 h-5 text-emerald-400" />
        </div>
        Что будет после оплаты?
      </h4>
      
      <p className="text-zinc-300 text-base sm:text-lg leading-relaxed mb-4">
        После верификации оплаты мы свяжемся с вами через указанные контакты, 
        а на указанную почту вышлем материалы которые вы заказали.
      </p>
      
      <div className="flex flex-wrap gap-4">
        <div className="flex items-center gap-2 text-emerald-400">
          <MessageCircle className="w-5 h-5" />
          <span className="font-medium">Telegram/WhatsApp</span>
        </div>
        <div className="flex items-center gap-2 text-emerald-400">
          <Mail className="w-5 h-5" />
          <span className="font-medium">Email с материалами</span>
        </div>
      </div>
    </div>
  );
};

export default AfterPaymentBlock;
